import { AlertCircle } from "lucide-react"
import { Button } from "@/shared/ui/button"

interface LoadErrorStateProps {
	message?: string
	onRetry?: () => void
}

export function LoadErrorState({
	message = "Не удалось загрузить данные. Проверьте подключение и попробуйте снова.",
	onRetry,
}: LoadErrorStateProps) {
	return (
		<div className="rounded-3xl border border-dashed border-destructive/40 bg-destructive/5 px-4 py-10 text-center">
			<AlertCircle className="mx-auto mb-3 size-8 text-destructive/80" />
			<p className="text-sm text-muted-foreground">{message}</p>
			{onRetry ? (
				<Button
					type="button"
					variant="outline"
					size="sm"
					className="mt-4 rounded-full"
					onClick={onRetry}
				>
					Повторить
				</Button>
			) : null}
		</div>
	)
}
